const api_url = 'https://eir9z34uz3.execute-api.eu-central-1.amazonaws.com/api';

export default api_url;
